import { StatusService } from '../../services/authentication/status.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-relogin-alert',
  templateUrl: './relogin-alert.component.html',
  styleUrls: ['./relogin-alert.component.scss'],
})
export class ReloginAlertComponent {
  authService: AuthenticationService;
  statusService: StatusService;

  constructor(authenticationService: AuthenticationService, statusService: StatusService) {
    this.authService = authenticationService;
    this.statusService = statusService;
  }

  reLogin() {
    if (this.authService.userRequest) {
      this.authService.login(
        this.authService.userRequest,
        () => {},
        () => {},
      );
    }
  }
}
